import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Alert } from "reactstrap";
import { ApplicationState } from "../../store";

// At runtime, Redux will merge together...
type PaymentProps = 
  RouteComponentProps<{ responsedescription: string }> & // ... plus incoming routing parameters
  MyComponentOwnProps;

class ErrorMessage extends React.PureComponent<PaymentProps> {
  UnCancelButton:
    | ((event: React.SyntheticEvent<HTMLIFrameElement, Event>) => void)
    | undefined;
  ForceClose:
    | ((event: React.SyntheticEvent<HTMLIFrameElement, Event>) => void)
    | undefined;

  constructor(props: Readonly<PaymentProps>) {
    super(props);

    this.ForceClose = (event: React.SyntheticEvent<HTMLIFrameElement>) => {
      window.close();
    };

    
  }
  

  public render() {
    
    return (
      <div key="errors">
        
          <Alert color="danger">
            There was a problem pulling your invoices.  Please try again later.
          </Alert>
      </div>
    );
  }
 
}

interface MyComponentOwnProps {
  responsedescription: string | null;
}

const mapStateToProps = function (state: ApplicationState) {
  return {
    
  };
};

export default connect(
  mapStateToProps, // Selects which state properties are merged into the component's props
)(ErrorMessage as any);
